module.exports = __webpack_public_path__ + "static/media/changPassword.640128c5.svg";